/* src/app/components/company/company-add-edit/company-add-edit.component.css */
.btn-group.flex-wrap .btn {
  margin-bottom: 4px;
}
.btn-outline-primary.active:hover {
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
  color: var(--bs-btn-active-color);
  box-shadow: none;
}
/*# sourceMappingURL=company-add-edit.component.css.map */
